var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"d-none d-sm-flex bg-image",style:('background-image: url(' + _vm.image + ')'),attrs:{"cols":"12","md":"5"}})}
var staticRenderFns = []

export { render, staticRenderFns }